<script>
export default {
  data: () => ({
    searchString: '',
  }),
};
</script>

<template>
  <v-text-field
    v-show="false"
    id="navbar-search-input"
    v-model="searchString"
    outlined
    clearable
    color="primary"
    dense
    hide-details
    label="Suche"
    style="max-width: 300px;margin-right:12px;">
  </v-text-field>
</template>
